
import { defineComponent, PropType, VNode } from "vue";

export default defineComponent({
  name: "component-reflecter",
  props: {
    component: {
      type: Object as PropType<VNode>,
    },
  },
  mounted() {
    console.log("--------------------");
    console.log(this.component);

    console.log("--------------------");
  },
});
